import { render, staticRenderFns } from "./BlockQuiz.vue?vue&type=template&id=749158c8&scoped=true&lang=pug"
import script from "./BlockQuiz.vue?vue&type=script&lang=ts"
export * from "./BlockQuiz.vue?vue&type=script&lang=ts"
import style0 from "./BlockQuiz.vue?vue&type=style&index=0&id=749158c8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749158c8",
  null
  
)

export default component.exports